import React from 'react';

// --------------------------------------------------------------------------- //
// QEUK international attribution block.
//
// Displayed ONLY on international waitlist landings (`/hk`, `/my`, `/in-hi`,
// `/pk`, `/id`, `/th`, `/bd`, `/tn`).  The Sri Lankan surfaces (main `/`,
// `/register`, `/verify`, `/id-card`, `/try`) use the domestic parent-company
// wording instead — DO NOT import this component there.  See
// `/app/_inspect/genius-one-plus/docs/BRAND_AND_PAYMENT_ROUTING.md` for the
// two-entity architecture.
//
// Both the Sri Lankan domestic entity and Qualification Evaluation UK Ltd
// are legitimate legal vehicles owned by the founder — sister entities, not
// shell companies of each other.  Do NOT position one as endorsing / co-issuing
// the other's certificates.
// --------------------------------------------------------------------------- //

/**
 * <QeukHeroAttribution />
 * Small muted line rendered directly under the hero sub-heading.
 */
export function QeukHeroAttribution({ testidPrefix }) {
  return (
    <p
      className="text-xs uppercase tracking-widest text-slate-500 mb-4"
      data-testid={`${testidPrefix || 'intl'}-qeuk-hero-attribution`}
    >
      A Qualification Evaluation UK Ltd Programme
    </p>
  );
}

/**
 * <QeukTrustNudge />
 * Rendered inside/below the waitlist card so payment expectations are set
 * BEFORE the reader hits the "Notify me" button.
 */
export function QeukTrustNudge({ testidPrefix }) {
  return (
    <p
      className="text-[11px] italic text-slate-500 border-t border-slate-200 pt-3 mt-3 leading-relaxed"
      data-testid={`${testidPrefix || 'intl'}-qeuk-trust-nudge`}
    >
      International enrollments are managed by Qualification Evaluation UK Ltd.
      When you enroll, payment will be received in GBP by Qualification
      Evaluation UK Ltd (UK). Your bank statement will show{' '}
      &ldquo;QUALIFICATION EVALUATION UK LTD&rdquo; as the payee.
    </p>
  );
}

/**
 * <QeukPaymentPlaceholder />
 * Subtle dev-visible marker so the founder can spot the "fill me in" slot.
 * Rendered with opacity-40 and hidden on mobile — visible enough for internal
 * review, quiet enough not to spook actual waitlist visitors.
 *
 * TODO: FOUNDER TO CONFIRM UK PAYMENT DETAILS BEFORE PHASE 3 LAUNCH
 *       - UK bank name
 *       - Account number (8 digits)
 *       - Sort code (XX-XX-XX)
 *       - GBP price per month (likely GBP 5-15)
 */
export function QeukPaymentPlaceholder({ testidPrefix }) {
  return (
    <aside
      className="hidden md:block opacity-40 hover:opacity-90 transition mt-6 rounded-md border border-dashed border-slate-400 bg-slate-50 p-3 text-[10px] font-mono text-slate-700 leading-snug"
      data-testid={`${testidPrefix || 'intl'}-qeuk-payment-placeholder`}
      aria-hidden="true"
      title="Internal dev placeholder — filled by founder before Phase 3 launch"
    >
      <div className="font-semibold text-slate-800 mb-1">
        UK Bank Payment Details — TO BE SET BY FOUNDER
      </div>
      <div>Account Name: Qualification Evaluation UK Ltd</div>
      <div>Bank:         [TO CONFIRM]</div>
      <div>Account No:   [TO CONFIRM]</div>
      <div>Sort Code:    [TO CONFIRM]</div>
      <div>GBP price:    [TO CONFIRM — likely GBP 5-15/month]</div>
    </aside>
  );
}

/**
 * <QeukFooter />
 * Small footer line rendered at the very bottom of every international page.
 */
export function QeukFooter({ testidPrefix }) {
  return (
    <p
      className="text-xs text-muted-foreground mt-3"
      data-testid={`${testidPrefix || 'intl'}-qeuk-footer-attribution`}
    >
      Genius One Plus (International) — a programme of Qualification Evaluation
      UK Ltd, United Kingdom.
    </p>
  );
}
